
import env from "react-dotenv";

import React from "react";
import { createRoot } from 'react-dom/client';

import App from "./App";
import { Helmet } from "react-helmet";
import { CookiesProvider } from "react-cookie";
import Loading from "./game/component/html-component/loading";
import { InitiateProvider } from "./blockhain/provider/initiate.provider";
import { Provider } from 'react-redux';
import store from '@redux/store';

const rootElement = document.getElementById("root");
const root = createRoot(rootElement); // createRoot(container!) if you use TypeScript
root.render(
    <>
        <Loading />
        <Helmet>
            <meta name="viewport" content="width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no" />
            <meta name="HandheldFriendly" content="true" />
        </Helmet>
        <Provider store={store}>
            <InitiateProvider>
                <CookiesProvider>
                    <App />
                </CookiesProvider>
            </InitiateProvider>
        </Provider>
    </>
);
